import React, { useState, useEffect, useImperativeHandle, forwardRef } from "react";

import { Button, Input, Radio, Select } from 'antd';
import { Method_POST } from "../../../../../../../service/api";
import { Box, CircularProgress } from "@mui/material";
import { toast } from "react-toastify";

const CadastrarCliente = forwardRef(({ info, numeroSolicita, fecharModalCadastrarCliente, setIsModalCadastrarCliente, modo, avancarOS, fetchData, clienteExists, visibleBtn }, ref) => {
  const [radioDesassociarCliente, setRadioDesassociarCliente] = useState(false);


  const [listCarteira, setListCarteira] = useState([]);
  const [listEquipe, setListEquipe] = useState([]);
  const [loading, setLoading] = useState("");
  const [selectedOption, setSelectedOption] = useState("");

  const [dadosCliente, setdadosCliente] = useState({
    novoCliente: "",
    atribuirIdClienteExistente: "",
    carteiraCliente: "",
    equipe: ""
  })

  const [inputId, setInputId] = useState(false);
  const [idClienteExistente, setIdClienteExistente] = useState(false);
  const [selectCarteira, setSelectCarteira] = useState(false);
  const [selectEquipe, setSelectEquipe] = useState(false);


  useEffect(() => {
    fetchCarteiraListar();
    fetchEquipeListar();
    clienteIdProximo();
  }, [selectedOption === "novoCliente"])

  useEffect(() => {
    if (modo !== 'optionCadastrarCliente') {
      setRadioDesassociarCliente(true);

    } else {
      setRadioDesassociarCliente(false);
    }
  }, [modo]);


  const cadastrarCliente = async () => {
    if (selectedOption === "novoCliente") {
      if (!dadosCliente.carteiraCliente) {
        toast.info("Selecione uma carteira");
        return;
      }
      if (!dadosCliente.equipe) {
        toast.info("Selecione uma equipe");
        return;
      }
    }

    if (selectedOption === "alterarCarteira") {
      if (!dadosCliente.carteiraCliente) {
        toast.info("Selecione uma carteira");
        return;
      }
      if (!dadosCliente.equipe) {
        toast.info("Selecione uma equipe");
        return;
      }
    }

    if (selectedOption === "clienteExistente") {
      if (!dadosCliente.atribuirIdClienteExistente) {
        toast.info("Você precisa digitar um ID de um cliente");
        return;
      }
      trocarCliente();
      return;
    }

    // Preparando os dados de verificação
    const verificarDados = {
      tipoPessoa: info.cnpjEmpresa ? "PJ" : "PF",
      cpf: info.cnpjEmpresa ? "" : info.cpf,
      cnpj: info.cnpjEmpresa,
    };

    try {
      // fazer a verificação do cliente antes de cadastrar
      const verificarUrl = `/ordem-servico/cliente/verificar`;
      const verificarResponse = await Method_POST(
        verificarUrl,
        verificarDados
      );

      if (verificarResponse && verificarResponse.erro) {
        const erro = verificarResponse.erro;

        // Se houver erro relacionado ao cadastro duplicado (cliente já existe)
        if (
          erro.categoria?.id === "B" &&
          (erro.mensagem.startsWith("O cliente de CPF [") ||
            erro.mensagem.startsWith("O cliente de CNPJ [")) &&
          erro.mensagem.endsWith("se encontra cadastrado")
        ) {
          // Exibe uma confirmação ao usuário para cadastrar um novo cliente
          const confirmaCadastro = window.confirm(
            `${erro.mensagem}.\n\nConfirma o cadastro de um novo registro?`
          );

          if (!confirmaCadastro) {
            return; // Se o usuário cancelar, interrompe o cadastro
          }
        } else {
          // Outros erros relacionados ao cadastro
          console.warn("Atenção:", erro.id, erro.mensagem);
          return;
        }
      }

      // Cadastrar depois da verificação
      const url = `/ordem-servico/cliente/cadastrar`;
      const data = {
        cliente: {
          id: dadosCliente.novoCliente,
          carteira: {
            id: dadosCliente.carteiraCliente,
          },
          equipe: {
            id: dadosCliente.equipe,
          },
        },
        id: numeroSolicita,
      };

      // Faz a chamada para cadastrar o cliente
      const response = await Method_POST(url, data);

      if (response) {
        console.log("Cliente cadastrado com sucesso!");
        fecharModalCadastrarCliente();
        await fetchData(); // Atualiza os dados após o cadastro
      }
    } catch (error) {
      console.error("Erro ao cadastrar cliente:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const trocarCliente = async () => {
    if (selectedOption === "novoCliente") {
      if (!dadosCliente.carteiraCliente) {
        toast.info("Selecione uma carteira");
        return;
      }
      if (!dadosCliente.equipe) {
        toast.info("Selecione uma equipe");
        return;
      }
    }

    if (selectedOption === "alterarCarteira") {
      if (!dadosCliente.carteiraCliente) {
        toast.info("Selecione uma carteira");
        return;
      }
      if (!dadosCliente.equipe) {
        toast.info("Selecione uma equipe");
        return;
      }
    }

    if (selectedOption === "clienteExistente" && dadosCliente.novoCliente === "") {
      toast.info("Você precisa digitar um ID de um cliente");
      return;
    }

    setLoading(true);
    try {
      if (selectedOption === "novoCliente") {
        await cadastrarCliente();
        return;
      }

      const data = {
        id: String(numeroSolicita),
        cliente: {
          id: "",
        },
      };

      // Preenche o payload para "clienteExistente"
      if (selectedOption === "clienteExistente") {
        data.cliente.id = String(dadosCliente.atribuirIdClienteExistente);
      }

      // Preenche o payload para "alterarCarteira"
      if (selectedOption === "alterarCarteira") {
        data.cliente.id = info.clienteId ? String(info.clienteId) : "-1";
        data.cliente.carteira = { id: String(dadosCliente.carteiraCliente) };
        data.cliente.equipe = { id: String(dadosCliente.equipe) };
      }

      // Payload para "desassociarCliente"
      if (selectedOption === "desassociarCliente") {
        data.cliente.id = "-1";
        delete data.cliente.carteira;
        delete data.cliente.equipe;
      }

      const url = `/ordem-servico/cliente/trocar`;
      const response = await Method_POST(url, data);

      if (response) {
        fecharModalCadastrarCliente();
        setIsModalCadastrarCliente(false);
        toast.success("Cliente trocado com sucesso!");
        fetchData();
        if (!clienteExists) {
          avancarOS();
          return;
        }
      }

      if (response) {
        if (response.erro.categoria.id === "B") {
          toast.error(response.erro.mensagem);
          return;
        }
      }
    } catch (error) {
      console.error("Erro ao buscar dados:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchCarteiraListar = async () => {
    setLoading(true);
    try {
      const url = `/carteira/cliente/listar`;
      const data = {};

      const response = await Method_POST(url, data);

      if (response) {
        setListCarteira(response)
        console.log("Dados das Carteiras:", response);
      }
    } catch (error) {
      console.error("Erro ao buscar dados:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchEquipeListar = async () => {
    setLoading(true);
    try {
      const url = `/equipe/listar`;
      const data = {};

      const response = await Method_POST(url, data);

      if (response) {
        setListEquipe(response);
        console.log("Dados da Equipe:", response);
      }
    } catch (error) {
      console.error("Erro ao buscar dados:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeCarteira = (value) => {
    setdadosCliente((prevState) => ({
      ...prevState,
      carteiraCliente: value,
    }));
    console.log(`selected ${value}`);
  };

  const handleChangeEquipe = (value) => {
    setdadosCliente((prevState) => ({
      ...prevState,
      equipe: value,
    }));
    console.log(`selected ${value}`);
  };

  const clienteIdProximo = async () => {
    setLoading(true);
    try {
      const url = `/ordem-servico/cliente/id/proximo`;
      const data = {};

      const response = await Method_POST(url, data);

      if (response) {
        console.log("dados:", response);
        setdadosCliente({ novoCliente: response.id })
        console.log("ID:", response.id)
      }
    } catch (error) {
      console.error("Erro ao buscar dados:", error.message);
    } finally {
      setLoading(false);
    }
  }

  const onChangeRadio = (event) => {
    const selectedValue = event.target.value;
    setSelectedOption(selectedValue);

    if (selectedValue === "novoCliente") {
      setInputId(true);
      setIdClienteExistente(false);
      setSelectCarteira(true);
      setSelectEquipe(true);
    } else if (selectedValue === "clienteExistente") {
      setIdClienteExistente(true);
      setInputId(false);
      setSelectCarteira(false);
      setSelectEquipe(false);
    } else if (selectedValue === "alterarCarteira") {
      setInputId(true);
      setIdClienteExistente(false);
      setSelectCarteira(true);
      setSelectEquipe(true);
    } else if (selectedValue === "desassociarCliente") {
      setInputId(false);
      setIdClienteExistente(false);
      setSelectCarteira(false);
      setSelectEquipe(false);

      //limpa os campos
      setdadosCliente({
        novoCliente: "",
        carteiraCliente: "",
        equipe: ""
      })
    }
  };

useImperativeHandle(ref, () => ({
  cadastrarOuTrocar: async () => {
    try {
      if (selectedOption === "clienteExistente") {
        await trocarCliente();
      } else {
        await cadastrarCliente();
      }

      return true; // deu certo -> pode avançar
    } catch (err) {
      console.error("Erro:", err);
      return false; // erro -> não avança
    }
  },
}));


  return (
    <>
      <div>
        {loading ? (
          <>
            <Box sx={{ display: "flex" }}>
              <CircularProgress />
            </Box>
          </>
        ) : (
          <>
            <strong>Instruções</strong>
            <p className="font-size-14">
              Informe o código de identificação a ser atribuído a este
              cliente.
            </p>

            <p>Escolha a ação que deseja realizar:</p>

            <Radio.Group onChange={onChangeRadio} value={selectedOption}>
              <div style={{ display: "flex" }}>
                <div style={{ marginLeft: 5, marginBottom: 10 }}>
                  <Radio value="novoCliente">
                    Criar um novo cliente.
                  </Radio>
                </div>
                <div style={{ marginLeft: 5, marginBottom: 10 }}>
                  <Radio value="clienteExistente">
                    Atribuir esta OS a um cliente já existente.
                  </Radio>
                </div>
                {radioDesassociarCliente && (
                  <div style={{ marginLeft: 5, marginBottom: 10 }}>
                    <Radio value="desassociarCliente">
                      Desassociar o cliente desta OS.
                    </Radio>
                  </div>
                )}
              </div>
              <div style={{ marginLeft: 5, marginBottom: 10 }}>
                <Radio value="alterarCarteira">
                  Alterar a Carteira e Equipe deste cliente.
                </Radio>
              </div>
            </Radio.Group>

            <div style={{ display: "flex" }}>
              {inputId && (
                <div style={{ marginLeft: 5, marginBottom: 10 }}>
                  <p>Novo Cliente Id</p>
                  <Input
                    placeholder={
                      selectedOption === "clienteExistente"
                        ? "Digite o ID do cliente"
                        : dadosCliente.novoCliente
                    }
                    value={dadosCliente.novoCliente}
                    style={{ width: 240 }}
                    disabled={selectedOption === "alterarCarteira" ? true : false}
                  />
                </div>
              )}

              {idClienteExistente && (
                <div style={{ marginLeft: 5, marginBottom: 10 }}>
                  <p>Digite o ID do cliente</p>

                  <Input
                    placeholder={"Cliente ID"}
                    value={dadosCliente.atribuirIdClienteExistente}
                    style={{ width: 240 }}
                    onChange={(event) =>
                      setdadosCliente((prevState) => ({
                        ...prevState,
                        atribuirIdClienteExistente: event.target.value,
                      }))
                    }
                  />
                </div>
              )}

              {selectCarteira && (
                <div style={{ marginLeft: 5, marginBottom: 10 }}>
                  <p>Carteira Cliente</p>

                  <Select
                    style={{ width: 240 }}
                    placeholder={"Carteira" + info.carteiraId === "" ? "" : info.carteiraId}
                    value={dadosCliente.carteiraCliente}
                    onChange={handleChangeCarteira}
                    options={listCarteira.map((carteira) => ({
                      value: carteira.id,
                      label: carteira.nome,
                    }))}
                  />
                </div>
              )}

              {selectEquipe && (
                <div style={{ marginLeft: 5, marginBottom: 10 }}>
                  <p>Equipe</p>

                  <Select
                    style={{ width: 240 }}
                    placeholder={"Equipe " + info.equipeId === "" ? "" : info.equipeId}
                    value={dadosCliente.equipe}
                    onChange={handleChangeEquipe}
                    options={listEquipe.map((equipe) => ({
                      value: equipe.id,
                      label: equipe.nome,
                    }))}
                  />
                </div>
              )}
            </div>
          </>
        )}

        {visibleBtn ? (
          null
        ) : (
          <Button onClick={modo === 'optionCadastrarCliente' ? cadastrarCliente : trocarCliente}>Salvar</Button>
        )}
      </div>

    </>
  );
});

export default CadastrarCliente;
